import { render } from "./MultiselectPreguntas.vue?vue&type=template&id=3fb04a58&scoped=true"
import script from "./MultiselectPreguntas.vue?vue&type=script&lang=js"
export * from "./MultiselectPreguntas.vue?vue&type=script&lang=js"

import "./MultiselectPreguntas.vue?vue&type=style&index=0&id=3fb04a58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb04a58"]])

export default __exports__